import { Component, OnInit } from '@angular/core';
import { ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MdDialog } from '@angular/material';
import { RecoverPasswordService } from '../../services/recover-password.service';
import { RecoverStatus } from '../../interfaces/recover-status';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-recovery-password',
  templateUrl: './recovery-password.component.html',
  styleUrls: ['./recovery-password.component.css']
})
export class RecoveryPasswordComponent implements OnInit {

  private viewContainerRef: ViewContainerRef;
  errorMessage: string;
  loading:boolean = false;
  form: FormGroup;

  emailRegex: any = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  constructor(private fb: FormBuilder, viewContainerRef:ViewContainerRef,
              private recover: RecoverPasswordService, private dialog: MdDialog,
              private router: Router) {
    this.viewContainerRef = viewContainerRef;
  }

  ngOnInit() {
    this.form = this.fb.group({
      email: [ null, Validators.compose([ Validators.required, Validators.pattern(this.emailRegex) ]) ]
    });
  }

  onPostRecovery(email:string) {
    this.loading = true;
    this.recover.sendRecoverRequest(email)
    .subscribe(
        status => this.processStatus(status),
        error => this.processError(error)
      );
  }

  //noinspection JSMethodCanBeStatic
  processStatus(status:RecoverStatus) {
    this.dialog.open(MessageBoxDialog, {data: {message: status.message, showIcon:true}});
    this.loading = false;
    this.router.navigate(['/login']);
  }

  processError(error) {
    this.dialog.open(MessageBoxDialog, {data: {message: 'Usuario no encontrado', showIcon:true}});
    this.errorMessage = error;
    this.loading = false;
  }

  gotoLogin(){this.router.navigate(['login'])}
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/recovery-password/recovery-password.component.ts